import type { TotpRepository } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { stringValueObject } from '@contexts/shared/domain';

export type VerifyTotpCodeInput = {
	token: string;
	code: string;
};

export type VerifyTotpCodeUseCase = UseCase<VerifyTotpCodeInput, void>;

export function verifyTotpCodeBuilder(totpRepository: TotpRepository): VerifyTotpCodeUseCase {
	return async function verifyTotpCode(input: VerifyTotpCodeInput): Promise<void> {
		const token = stringValueObject().validate('token', input.token);
		const code = stringValueObject().validate('code', input.code);

		await totpRepository.verifyCode(token, code);
	};
}
